import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {UtilService} from '../../services/util.service';
import {ProcessUserListModal} from './process-user-list.modal';
import {PipesModule} from '../../pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PipesModule
    ],
    declarations: [
        ProcessUserListModal
    ],
    exports: [
        ProcessUserListModal
    ],
    providers: [
        UtilService
    ]
})
export class ProcessUserListModalModule {
}
